import axios from 'axios';

const getList = (params) => axios.get('/fornecedor/ofertas', {
  params,
});
const get = (id) => axios.get(`/fornecedor/ofertas/${id}`, {});

const save = (oferta) => {
  if (oferta.id) {
    return axios.put(`/fornecedor/ofertas/${oferta.id}`, oferta);
  }
  return axios.post('/fornecedor/ofertas', oferta);
};

const getDuvidas = (id, params) => axios.get(`/fornecedor/ofertas/${id}/perguntas`, { params });
const responderDuvidas = (idPergunta, data) => axios.put(`/fornecedor/ofertas/perguntas/${idPergunta}`, data);

export default {
  getList,
  get,
  save,
  getDuvidas,
  responderDuvidas,
};
